/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { Button, Input, Label, InputSelect, Modal, Pagination, CustomLoading, Breadcrumb, SaveIcon } from "../../../Components";

/* 🔗 SERVICE */
import { CargosServices } from "../../../Services/cargosServices";

/* 🧠 REDUX */
import { useSelector } from "react-redux/es/hooks/useSelector";
import { store } from "../../../Redux/Store";
import { changeModal } from "../../../Redux/Actions";

/* 📁 ASSETS*/
import { Lupa } from "../../../Assets/icons";

/* 🎨 STYLES */
import { Container, CountContainer, LineTitle, TitleText, LineList, ListText, PageTitle, ContainerList, HeaderContainer, 
    InputContainer, FilterInput, ContainerHead, ContainerRow, ButtonsContainer, ContainerColumn} from "./styles";

/* 🔧 UTILS */
import { isValidField } from "../../../util/validate";

const ListRoles = () => {
    const { t } = useTranslation();

    document.title = t("administrative.sub-items.positions.list.document-title");

    const navigationFlow =  [
        { text: 'administrative', page: '/adm/cargos' },
        { text: 'positions', page: '/adm/cargos' }
    ]
    
    const [locations, setLocations] = useState([]);
    const [cargos, setCargos] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    
    const Services = useRef(new CargosServices());
    const AllocationField = useRef();
    const AllocationValue = useRef();
    const TitleField = useRef();
    const TitleValue = useRef();
    const DescriptionField = useRef();
    const DescriptionValue = useRef();
    const searchValue = useRef();
    
    const user = useSelector(state => state.userReducer);
    let active = useSelector(state => state.ModalReducer.name);

    const getCargos = async() => {
        let currentCargos = await Services.current.getAllCargos();
        setCargos(currentCargos);
        setIsLoading(false)
    }

    // Busca alocações que o usuário consegue visualizar
    const getLocations = async() => {
        try {
            let AllLocations = await Services.current.getLocations();
            const allAllocations = AllLocations.Entidades.map(entity => ({
                id: entity.id,
                name: entity.name,
            }))
            setLocations(allAllocations);
        } catch (error) {
            
        }
    }

    useEffect(() => {
        getCargos();
        getLocations();
    }, []);

    const aplyFilter = async() => {
        setIsLoading(true);
        let currentCargos = await Services.current.getAllCargos(searchValue.current);
        setCargos(currentCargos);
        setIsLoading(false);
    }

    // Salva as edições do usuário
    const Save = async() => {
        store.dispatch(changeModal(''));
        if(isValidField(TitleValue.current) && isValidField(DescriptionValue.current)){
            let form = new FormData();
            if(TitleValue.current){form.append('title', TitleValue.current)}
            if(AllocationValue.current){form.append('allocation_id', AllocationValue.current)}
            if(DescriptionValue.current){form.append('description', DescriptionValue.current)}
    
            await Services.current.SaveCargo(form);
        }else{
            toast(t("message.save"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    const changepage = async(page) => {
        setIsLoading(true);
        let currentCargos = await Services.current.getAllCargos(searchValue.current, page);
        setCargos(currentCargos);
        setIsLoading(false);
    }

    return(
        <>
            <Container>
                <Breadcrumb flow={navigationFlow}/>
                <PageTitle>
                    {t("administrative.sub-items.positions.list.page-title")}
                </PageTitle>

                <HeaderContainer>
                    <InputContainer>
                        <img src={Lupa} alt={t("inputs.search-position.alt")}></img>
                        <FilterInput
                            // onBlur={()=>Aplyfilter()}
                            onKeyDown={(e) => e.key === 'Enter' && aplyFilter()}
                            onChange={(e) => searchValue.current = e.target.value}
                            placeholder={t("inputs.search-position.placeholder")}
                        />
                    </InputContainer>

                    <Button width={'fit-content'} text={t("buttons.apply")} onClick={() => aplyFilter()}></Button>
                </HeaderContainer>
                
                <ContainerHead>
                    <CountContainer>
                        {t("administrative.sub-items.list-total") + " " + cargos?.data?.length + " " + t("administrative.sub-items.positions.list.positions") }
                    </CountContainer>
                    {user?.user?.can?.includes('role.create') ?
                        <Button onClick={() => store.dispatch(changeModal('newcargo'))} width={'fit-content'} icon={''} text={t("buttons.register-position")}></Button>
                    :<></>}
                </ContainerHead>

                <ContainerList>
                    <LineTitle>
                        <TitleText>{t("header-table.name") }</TitleText>
                        <TitleText>{t("header-table.description")}</TitleText>
                        <TitleText></TitleText>
                    </LineTitle>

                    {isLoading?
                        <CustomLoading width={'150px'} height={'150px'}/>
                    :
                        cargos?.data?.map((item) => (
                            <LineList key={item.id} href={user?.user?.can?.includes('role.view') ? `/adm/cargos/${item.id}` : undefined}>
                                <ListText>{item.title}</ListText>
                                <ListText>{item.description}</ListText>
                                <ListText></ListText>
                            </LineList>
                        ))
                    }
                </ContainerList>

                <Pagination last_page={cargos?.meta?.last_page} currentpage={cargos?.meta?.current_page} changepage={changepage}/>
            </Container>
            
            <Modal title={t("modal.register-position.title")} name={'newcargo'} width={'60%'} height={'60%'} >
                {active === 'newcargo' ?
                <>
                    <ContainerRow onSubmit={(e) => e.preventDefault()}>
                        <ContainerColumn>
                            <Label text={t("inputs.title.label")} aling="flex-start"/>
                            <Input 
                                aling="flex-start"
                                id='title' 
                                name='title' 
                                type="text" 
                                placeholder={t("inputs.title.placeholder")}
                                innerRef={TitleField}
                                invalidMessage={t("inputs.title.invalid-message")}
                                validationFunction={(text) => isValidField(text)}
                                onchange={(text) => TitleValue.current = text}> 
                            </Input>

                            <Label text={t("inputs.allocation-local.label")} aling="flex-start"/>
                            <InputSelect
                                key="alocacao"
                                name="alocacao"
                                id="alocacao"
                                placeholder={t("inputs.allocation-local.placeholder")}
                                invalidMessage={t("inputs.allocation-local.invalid-message")}
                                options={locations}
                                innerRef={AllocationField}
                                validationFunction={() => true}
                                onchange={(value) => AllocationValue.current = value}
                                >
                            </InputSelect>
                        </ContainerColumn>

                        <ContainerColumn>
                            <Label text={t("inputs.description.label")} aling="flex-start"/>
                            <Input 
                                aling="flex-start"
                                id='description' 
                                name='description' 
                                type="text" 
                                placeholder={t("inputs.description.placeholder")}
                                innerRef={DescriptionField}
                                invalidMessage={t("inputs.description.invalid-message")}
                                validationFunction={(text) => isValidField(text)}
                                onchange={(text) => DescriptionValue.current = text}> 
                            </Input>

                        </ContainerColumn>
                    </ContainerRow>      
                    <ButtonsContainer>
                        <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={() => Save()}/>
                        <Button text={t("buttons.cancel")} width={'150px'} color={'white-red'} onClick={() => store.dispatch(changeModal(''))}/>
                    </ButtonsContainer>
                </>
                : <></>}
            </Modal>
        </>
    )
}

export default ListRoles;